import { render } from "./AudienceNav.vue?vue&type=template&id=5c262454&scoped=true"
import script from "./AudienceNav.vue?vue&type=script&lang=js"
export * from "./AudienceNav.vue?vue&type=script&lang=js"

import "./AudienceNav.vue?vue&type=style&index=0&id=5c262454&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src28501298/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c262454"]])

export default __exports__